import Phaser from 'phaser';
import getConfig from '@config/baseConfig';
import sceneDefs from '@config/scenes';

/**
 * Initializes a Phaser game instance.
 * @param {Object} gameState - Initial game state passed to scenes
 * @returns {Phaser.Game} The initialized game instance
 */
export function initializeGame(gameState = {}) {
  const config = getConfig();
  const game = new Phaser.Game(config);

  game.__gameState = gameState;

  sceneDefs.forEach(({ key, scene, autoStart }) => {
    game.scene.add(key, scene, autoStart || false);
  });

  if (process.env.NODE_ENV !== 'production') {
    window.__game = game;
  }

  return game;
}
